(ns com.theplantscape.local-store.utils)

(defn namespace-map [hm-ns hm]
  (reduce-kv
   (fn [m k v]
     (assoc m (keyword hm-ns k) v))
   {}
   hm))

(defn remove-namespace-map [hm]
  (reduce-kv
   (fn [m k v]
     (assoc m (keyword (name k)) v))
   {}
   hm))
